export default __webpack_public_path__ + "static/media/intern2.d899bfdf.png";